export const YENGAPAY_MERCHANTS_COLLECTION = "yengapay_merchants";
export const YENGAPAY_USERS_COLLECTION = "yengapay_users";
